import * as Blockly from 'blockly/core';
import 'blockly/python';
import { AreaService } from '@/services/area.service';
import { CustomFieldDate } from '../../blocklyFieldDate';
import { createMinusField } from './field_minus';
//import { /*getAllowedOutputs,*/ getAllowedStatements } from './strata_compatibility_checks';
import { areaChange } from '../helper_functions';

Blockly.Blocks['globe_convergence'] = {
    init: function () {
        let areas = AreaService.getAreas();

        this.appendDummyInput("block_title")
            .appendField("Event Damage (e.g. Wind, Fire)");

        this.appendDummyInput("stormtime")
            .appendField("Event Time")

        this.appendDummyInput("temporal_extent")
            .appendField("From:     ", 'fromText')
            .appendField(new CustomFieldDate('2020-08-27', null, 'true'), 'fd')
            .appendField('      To:    ', 'toText')
            .appendField(new CustomFieldDate('2020-08-27', null, 'true'), 'td')
            .setVisible(true)

        this.appendDummyInput("changetime")
            .appendField("Changes between")

        this.appendDummyInput("time_period")
            .appendField(new Blockly.FieldDropdown([
                ["7", "7"],
                ["14", "14"],
                ["30", "30"],
                ["60", "60"],
                ["90", "90"]
            ]), "timeperiodb")
            .appendField("days before   ")
            .appendField(new Blockly.FieldDropdown([
                ["7", "7"],
                ["14", "14"],
                ["30", "30"],
                ["60", "60"],
                ["90", "90"]
            ]), "timeperioda")
            .appendField("days after")

        this.appendDummyInput('area_input')
            .appendField("Area ")
            .appendField(new Blockly.FieldDropdown(areas), "area")

        this.appendDummyInput("empty_row");

        this.appendDummyInput("INDICATOR0")
            .appendField("Indicators");

        this.appendStatementInput("INDICATORS0")

        this.appendDummyInput("INDICATOR1")
            .appendField("Masks")
        this.appendStatementInput("INDICATORS1")

        this.setNextStatement(true);
        this.setStyle('imagery');
        this.setHelpUrl("");

        this.itemCount_ = 1;

        this.areaSubscription = AreaService.areaChange$.subscribe( () => {
            let result = areaChange(this, "area_input", "area");
            if(!result) {
                this.areaSubscription.unsubscribe();
            }
        });
    },
    mutationToDom: function () {
        if (!this.itemCount_) {
            return null;
        }
        const container = Blockly.utils.xml.createElement('mutation');
        container.setAttribute('item', this.itemCount_);
        return container;
    },

    /**
     * @param {!Element} xmlElement XML storage element.
     * @this {Blockly.Block}
     */
    domToMutation: function (xmlElement) {
        const targetCount = parseInt(xmlElement.getAttribute('item'), 10) || 0;
        this.updateShape_(targetCount);
    },

    /**
     * @param {number} targetCount The target number of else-if inputs.
     * @this {Blockly.Block}
     * @private
     */
    updateShape_: function (targetCount) {
        while (this.itemCount_ < targetCount) {
            this.addItem_();
        }
        while (this.itemCount_ > targetCount) {
            this.removeItem_();
        }
    },

    plus: function () {
        this.addItem_();
    },

    /**
     * index.
     * @see removeInput_
     * @param {number} index The index of the else-if input to "remove".
     * @this {Blockly.Block}
     */
    minus: function (index) {
        if (this.itemCount_ == 0) {
            return;
        }
        this.removeItem_(index);
    },

    /**
     * Adds an else-if and a do input to the bottom of the block.
     * @this {Blockly.Block}
     * @private
     */
    addItem_: function () {
        if (this.itemCount_ >= 2) {
            console.log("cannot add more than 3 indicator buckets");
            return;
        }
        this.itemCount_++;
        this.appendDummyInput('INDICATOR' + this.itemCount_)
            .appendField(createMinusField(this.itemCount_), 'MINUS' + this.itemCount_)
            .appendField("Indicators").appendField(new Blockly.FieldDropdown([
                ["+ (ADD)", "add"],
                ["* (MULTIPLY)", "multiply"],
                ["  (MASK)", "mask"]]), "operator1");
        this.appendStatementInput("INDICATORS" + this.itemCount_)
    },

    /**
     * @param {?number=} index The index of the input to "remove", or undefined
     *     to remove the last input.
     * @this {Blockly.Block}
     * @private
     */
    removeItem_: function (/*index = undefined*/) {
        this.removeInput('INDICATOR' + this.itemCount_);
        this.removeInput('INDICATORS' + this.itemCount_);
        this.itemCount_--;
    }
};
